import {
    USER_LOGOUT,   FETCH_USER, ADD_USER,FETCH_USERS,DELETE_USER,UPDATE_USER,
    REMOVE_SELECTED_USERS,ADD_SELECTED_USERS,CLEAR_SELECTED_USERS} from "actions/actionTypes";
var _ = require('lodash');

const initialState = {data: [], fetched: false,total: 'initial', selectedUsers:[]};
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_USERS:
            console.log(FETCH_USERS, action);
            return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                fetched: true
            }
        case FETCH_USER:
           console.log('FETCH_USER', state, action.payload.data);
            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                total: 1,
                fetched: state.fetched
            }
        case UPDATE_USER:
            console.log('UPDATE_USER', state, action.payload);

            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)],
                fetched: state.fetched
            }
        case ADD_USER:
         //   console.log('ADD_USER', state, action.payload);

            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                fetched: state.fetched
            }

        case DELETE_USER:
            console.log('DELETE_USER', action.payload);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return {
                data: [...state.data.slice(0, itemIndex),
                    ...state.data.slice(itemIndex + 1)],
                fetched: state.fetched
            }
        case ADD_SELECTED_USERS:
         //   console.log('ADD_SELECTED_USERS', state,  action.payload);
            var selectedUsersToAdd =_.map( action.payload, function (seller) {
                return seller._id;
            });
            var updatedSelectedUsers = _.uniq(state.selectedUsers.concat(selectedUsersToAdd));
            return {
                ...state,
                selectedUsers: updatedSelectedUsers
            }
        case CLEAR_SELECTED_USERS:
            console.log('CLEAR_SELECTED_USERS', state,  action.payload);
            return {
                ...state,
                selectedUsers: []
            }
        case REMOVE_SELECTED_USERS:
            console.log('REMOVE_SELECTED_USERS', state,  action.payload);
            var selectedUsersToRemove =_.map( action.payload, function (seller) {
                return seller._id;
            });
            var updatedSelectedUsers =  _.uniq(_.difference(state.selectedUsers, selectedUsersToRemove));

            return {
                ...state,
                selectedUsers: updatedSelectedUsers,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// Get record by id
export const getUser = (state, id) => {
    return state.adminUsers.data.filter(record => record._id === id)[0];
}


